import { call, put, select, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import * as actionTypes from './action-types';
import * as assignCourseActions from '../assign-courses/actions';
import getProductId from '../../selectors/product';

export function* getDefaultCourses() {
    const productId = yield select(getProductId);
    const payload = yield call(api.getDefaultCourses, { productId });
    if (payload.status === 200) {
        yield put(actions.getDefaultCoursesSuccess(payload.data));
    } else {
        yield put(actions.getDefaultCoursesFailure());
    }
}

export function* getDefaultCoursesSaga() {
    yield takeLatest(actionTypes.GET_ADMIN_DEFAULT_COURSE_REQUEST, getDefaultCourses);
}

export function* checkCommonTasks(data) {
    const payload = yield call(api.checkCommonTasks, data);
    if (payload.status === 200) {
        yield put(actions.checkCommonTasksSuccess(payload.data.assignedTasksId));
    } else {
        yield put(actions.checkCommonTasksFailure());
    }

    yield put(assignCourseActions.deselectCourses());
}

export function* checkCommonTasksSaga() {
    yield takeLatest(actionTypes.CHECK_COMMON_TASKS_REQUEST, checkCommonTasks);
}

export function* assignCourses({ changeCourseRequests }) {
    const response = yield call(api.assignCourses, changeCourseRequests);
    if (response.status === 200) {
        yield put(actions.assignCoursesSuccess(false));
    } else {
        yield put(actions.assignCoursesFailure(false));
    }
}

export function* assignCoursesSaga() {
    yield takeLatest(actionTypes.ASSIGN_COURSES_REQUEST, assignCourses);
}



// WEBPACK FOOTER //
// ./app/containers/manage-assigned-courses/saga.js